// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"1a1c1b5b","255":"46c69b75","684":"98198c3e"}[chunkId] + ".chunk.js";
};